/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class MemberDiscountCode extends Mb {
    constructor() {
        super();
        this.baseUrl += '/memberDiscountCode';
    }

    findEnterpriseDiscountCodeList({
        certCatId,
        certExamType,
        codeSn,
        enterpriseCooperationName,
        enterpriseCooperationSn,
        orgId,
        enterpriseName,
        orderSn,
        fullName,
        mobile,
        userName,
        insertTime,
        writeOffEndTime,
        writeOffTime,
        updateTime,
        codeStatus,
        discountCodeType,
        schoolOrgId,
        enterpriseCooperationStatus,
        cmFullName,
        cmIdCardNo,
        cmTel,
        applyStatus,
        currentPage,
        pageSize,
    } = {}) {
        let insertBeginTime = null;
        let insertEndTime = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertBeginTime, insertEndTime] = insertTime;
        }
        let writeOffEndBeginTime = null;
        let writeOffEndEndTime = null;
        if (writeOffEndTime != null && writeOffEndTime.length === 2) {
            [writeOffEndBeginTime, writeOffEndEndTime] = writeOffEndTime;
        }
        let writeOffBeginTime = null;
        let writeOffEndTime2 = null;
        if (writeOffTime != null && writeOffTime.length === 2) {
            [writeOffBeginTime, writeOffEndTime2] = writeOffTime;
        }
        let updateBeginTime = null;
        let updateEndTime = null;
        if (updateTime != null && updateTime.length === 2) {
            [updateBeginTime, updateEndTime] = updateTime;
        }
        return super.get('/findEnterpriseDiscountCodeList', {
            certCatId,
            certExamType,
            codeSn,
            enterpriseCooperationName,
            enterpriseCooperationSn,
            orgId,
            enterpriseName,
            orderSn,
            fullName,
            mobile,
            userName,
            insertBeginTime,
            insertEndTime,
            writeOffEndBeginTime,
            writeOffEndEndTime,
            writeOffBeginTime,
            writeOffEndTime: writeOffEndTime2,
            updateBeginTime,
            updateEndTime,
            codeStatus,
            discountCodeType,
            schoolOrgId,
            enterpriseCooperationStatus,
            cmFullName,
            cmIdCardNo,
            cmTel,
            applyStatus,
            currentPage,
            pageSize,
        });
    }

    findMemberDiscountCodeList({
        certCatId,
        certExamType,
        codeSn,
        orgId,
        memberDiscountSn,
        memberDiscountName,
        orderSn,
        fullName,
        mobile,
        userName,
        insertTime,
        writeOffEndTime,
        writeOffTime,
        updateTime,
        codeStatus,
        discountCodeType,
        schoolOrgId,
        cmFullName,
        cmIdCardNo,
        currentPage,
        pageSize,
    } = {}) {
        let insertBeginTime = null;
        let insertEndTime = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertBeginTime, insertEndTime] = insertTime;
        }
        let writeOffEndBeginTime = null;
        let writeOffEndEndTime = null;
        if (writeOffEndTime != null && writeOffEndTime.length === 2) {
            [writeOffEndBeginTime, writeOffEndEndTime] = writeOffEndTime;
        }
        let writeOffBeginTime = null;
        let writeOffEndTime2 = null;
        if (writeOffTime != null && writeOffTime.length === 2) {
            [writeOffBeginTime, writeOffEndTime2] = writeOffTime;
        }
        let updateBeginTime = null;
        let updateEndTime = null;
        if (updateTime != null && updateTime.length === 2) {
            [updateBeginTime, updateEndTime] = updateTime;
        }
        return super.get('/findMemberDiscountCodeList', {
            certCatId,
            certExamType,
            codeSn,
            orgId,
            memberDiscountSn,
            memberDiscountName,
            orderSn,
            fullName,
            mobile,
            userName,
            insertBeginTime,
            insertEndTime,
            writeOffEndBeginTime,
            writeOffEndEndTime,
            writeOffBeginTime,
            writeOffEndTime: writeOffEndTime2,
            updateBeginTime,
            updateEndTime,
            codeStatus,
            discountCodeType,
            schoolOrgId,
            cmFullName,
            cmIdCardNo,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            return json;
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    findEnterpriseMemberList({
        fullName,
        mobile,
        userName,
        examApplyTime,
        sex,
        idCardNo,
        schoolOrgId,
        enterpriseName,
        enterpriseSn,
        currentPage,
        pageSize,
    } = {}) {
        let examApplyBeginTime = null;
        let examApplyEndTime = null;
        if (examApplyTime != null && examApplyTime.length === 2) {
            [examApplyBeginTime, examApplyEndTime] = examApplyTime;
        }
        return super.get('/findEnterpriseMemberList', {
            fullName,
            mobile,
            userName,
            examApplyBeginTime,
            examApplyEndTime,
            sex,
            idCardNo,
            schoolOrgId,
            enterpriseName,
            enterpriseSn,
            currentPage,
            pageSize,
        });
    }

    getEnterpriseMemberDetail({ id }) {
        return super.get('/getEnterpriseMemberDetail', { id }).then(json => {
            return json;
        });
    }

    findEnterpriseMemberCertExamApplyList({ id, currentPage, pageSize } = {}) {
        return super.get('/findEnterpriseMemberCertExamApplyList', {
            id,
            currentPage,
            pageSize,
        });
    }
}

export default new MemberDiscountCode();
export { MemberDiscountCode };
